import styled from 'styled-components';
import { rgba } from 'polished';

// Import styles
import { flex } from 'components/styles';

import { ReactComponent as IconTickSVG } from 'components/views/landing_page/assets/ic_tick.svg';

export const Item = styled.div`
	${flex({ fd: 'column', jc: 'space-between' })}
	padding: 2rem 2rem 2.8rem 2rem;
	height: 100%;
	position: relative;
	width: 100%;

	border-radius: 3.2rem;
	border: 1px solid #4c4a5a;
	background: linear-gradient(180deg, #05040e 0%, #0a0723 100%);
	backdrop-filter: blur(3.4rem);
`;

export const ItemImage = styled.img`
	aspect-ratio: 16 / 9;
	width: 100%;
	border-radius: 20px;
	background: #23222F;
	object-fit: contain;
	object-position: center;
	margin-bottom: 2rem;
`;

export const Channels = styled.p`
	color: ${({ theme }) => theme.palette.white};
	font-size: 1.4rem;
	font-weight: ${({ theme }) => theme.font.bold};
	line-height: 1.4em;
	width: 100%;
	margin-bottom: 1rem;
`;

export const Description = styled.div`
	${flex({ fd: 'column', ai: 'flex-start', jc: 'flex-start' })}
	gap: 1rem;
	width: 100%;
	margin-bottom: 3.6rem;

	h6 {
		color: ${({ theme }) => theme.palette.white};
		font-size: 1.4rem;
		font-weight: ${({ theme }) => theme.font.bold};
		line-height: 1.4em;
	}

	ul {
		list-style: none;
		${flex({ fd: 'column', ai: 'flex-start' })}
		gap: 1rem;

		li {
			display: grid;
			grid-template-columns: 2rem auto;
			column-gap: 0.5rem;
			color: ${({ theme }) => rgba(theme.palette.white, 0.8)};
		}
	}
`;

export const IconTick = styled(IconTickSVG)`
	flex-basis: 3.6rem;
	width: 2rem;
	height: 2rem;

	path {
		stroke: ${({ theme }) => rgba(theme.palette.white, 0.8)};
	}
`;

export const ButtonsWrapper = styled.div`
	width: 100%;
	${flex({ fd: 'column' })}
	row-gap: 2.8rem;
`;
